import { useNavigate, useParams } from 'react-router-dom'

import { Button } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import useAsyncAction from 'modules/core/hooks/useAsyncAction'
import i18n from 'modules/core/lib/i18n'

import { useMarkAsCompletedMaterializedProcess } from 'modules/processes/hooks/useMarkAsCompletedMaterializedProcess'

type Props = {
  materializedProcessId: string
  onSuccess: () => void
  onClose: () => void
}

const MarkAsCompletedMaterializedProcess = ({
  materializedProcessId,
  onSuccess,
  onClose,
}: Props) => {
  const { markAsCompletedMaterializedProcess } = useMarkAsCompletedMaterializedProcess()

  const { performAction, running: markingMaterializedProcess } = useAsyncAction(async () => {
    await markAsCompletedMaterializedProcess(materializedProcessId)

    onSuccess()
  })

  const modalTitle = i18n.t('processes.materialize_process.table.modals.complete.title_completed')
  const modalDescription = i18n.t('processes.materialize_process.table.modals.complete.description')
  const submitLabel = i18n.t('processes.materialize_process.table.modals.complete.button')

  const disabled = markingMaterializedProcess
  return (
    <Modal
      locked={markingMaterializedProcess}
      illustration="check"
      title={modalTitle}
      description={modalDescription}
      onSubmit={performAction}
      onClose={onClose}
      footer={
        <>
          <Button type="secondary" disabled={disabled} onClick={onClose}>
            {i18n.t('common.cancel')}
          </Button>
          <Button disabled={disabled} submit>
            {submitLabel}
          </Button>
        </>
      }
    ></Modal>
  )
}

const MarkAsCompletedMaterializedProcessModalPage = () => {
  const { id, materializedProcessId } = useParams()
  const navigate = useNavigate()

  const onClose = () => {
    navigate(-1)
  }

  if (!id) {
    onClose()
    return null
  }

  return (
    <MarkAsCompletedMaterializedProcess
      materializedProcessId={String(materializedProcessId)}
      onClose={onClose}
      onSuccess={onClose}
    />
  )
}

export default MarkAsCompletedMaterializedProcessModalPage
